import { render, staticRenderFns } from "./jrsbgl.vue?vue&type=template&id=75097d07&scoped=true&"
import script from "./jrsbgl.vue?vue&type=script&lang=js&"
export * from "./jrsbgl.vue?vue&type=script&lang=js&"
import style0 from "./jrsbgl.vue?vue&type=style&index=0&id=75097d07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75097d07",
  null
  
)

export default component.exports